<!--
 * @Author: 张志明
 * @Date: 2021-04-17 09:39:56
 * @LastEditTime: 2024-11-29 14:46:08
 * @Description:
-->
<template>
    <!-- 关键词排名查询 -->
    <div
        v-loading.fullscreen.lock="loading"
        class="keywords-ranking-query"
        :element-loading-text="loadingText"
        element-loading-background="rgba(0, 0, 0, .5)"
        element-loading-custom-class="loading-style"
        element-loading-spinner="el-icon-loading"
    >
        <notice showIcon
            >现排名查询每天只能查100个关键词，今日已查<em> {{ usedNum }} </em>/100。</notice
        >
        <query-settings
            ref="querySettings"
            :rest-num="totalNum - usedNum"
            :query-type="2"
            @search="search"
            @getPageRange="getPageRange"
        />
        <div v-show="pluginInstall">
            <rankListV2
                v-show="isShowList"
                ref="rankListV2"
                :link-to-analysis="linkToAnalysis"
                :table-data="tableData"
                :query="query"
                :show-pagination="true"
                @pageChange="pageChange"
                :productAnalysisPath="productAnalysisPath"
                :isUseNew="isUseNew"
            />
        </div>

        <div v-show="!pluginInstall">
            <rankList
                v-show="isShowList"
                ref="rankList"
                :link-to-analysis="linkToAnalysis"
                :table-data="tableData"
                :query="query"
                :show-pagination="showPagination"
                @pageChange="pageChange"
                :productAnalysisPath="productAnalysisPath"
                :isUseNew="isUseNew"
            />
        </div>
    </div>
</template>

<script>
import querySettings from '../components/querySettings';
import rankList from '../components/rankList';
import rankListV2 from '../components/rankListV2.vue';
import { dataAnalysis } from '../common/dataAnalysis';
import pluginsAnalysis from '../common/pluginsAnalysis';
import notice from './../../../components/notice/index.vue';
export default {
    name: 'KeywordsRankingQuery',
    components: { querySettings, rankList, notice, rankListV2 },
    mixins: [dataAnalysis, pluginsAnalysis],
    props: {
        linkToAnalysis: {
            type: Boolean,
            default: true,
        },
        checkVersion: Function,
        productAnalysisPath: {
            type: String,
            default: '/productAnalysis',
        },
        isUseNew: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showPagination: true,
            queryPage: 0,
        };
    },
    created() {
        judgeDazeCollector({
            name: '排名查询',
            operate: '关键词排名查询进入',
            tag: '',
            value: '',
        });
    },
    methods: {
        search(keywords, portPagesValue) {
            this.queryPage = portPagesValue;
            if (this.checkVersion()) {
                return;
            }
            this.showPagination = true;
            if (this.pluginInstall) {
                this.saveRankedQuery({ keywords });
            } else {
                this.beginStart(keywords);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
// .shop-ranking-query {}
</style>
